const WebsiteList = [
  {
    path: '',
    title: '最高人民法院诉讼服务网'
  },
  {
    path: '',
    title: '中国审判流程信息公开网'
  },
  {
    path: '',
    title: '中国庭审直播公开网'
  },
  {
    path: '',
    title: '中国执行信息公开网'
  },
  {
    path: '',
    title: '中国裁判文书网'
  },
  {
    path: '',
    title: '人民法院公告网'
  }
]
const cityList = [
  {
    title: '河南省法院-网址导航',
    type: 1,
    detail: {
      title: '河南省高级法院',
      path: '',
      type: 2,
      list: [
        {
          title: '郑州市中级法院',
          path: '',
          type: 3,
          list: [
            {
              title: '金水区法院',
              path: '',
              type: 4,
            },
            {
              title: '管城区法院',
              path: '',
              type: 4,
            },
            {
              title: '二七区法院',
              path: '',
              type: 4,
            },
            {
              title: '中原区法院',
              path: '',
              type: 4,
            },
            {
              title: '惠济区法院',
              path: '',
              type: 4,
            },
            {
              title: '新郑新区法院',
              path: '',
              type: 4,
            },
            {
              title: '高新区法院',
              path: '',
              type: 4,
            },
            {
              title: '荥阳市法院',
              path: '',
              type: 4,
            },
            {
              title: '登封法院',
              path: '',
              type: 4,
            },
            {
              title: '中牟县法院',
              path: '',
              type: 4,
            },
            {
              title: '新密法院',
              path: '',
              type: 4,
            }
          ]
        },
        {
          title: '洛阳市中级法院',
          path: '',
          type: 3,
          list: [
            {
              title: '高新区法院',
              path: '',
              type: 4,
            },
            {
              title: '老城区法院',
              path: '',
              type: 4,
            },
            {
              title: '偃师市法院',
              path: '',
              type: 4,
            },
            {
              title: '宜阳法院',
              path: '',
              type: 4,
            },
            {
              title: '瀍河法院',
              path: '',
              type: 4,
            },
            {
              title: '涧西法院',
              path: '',
              type: 4,
            },
            {
              title: '孟津法院',
              path: '',
              type: 4,
            },
            {
              title: '洛龙法院',
              path: '',
              type: 4,
            },
            {
              title: '栾川法院',
              path: '',
              type: 4,
            },
            {
              title: '汝阳法院',
              path: '',
              type: 4,
            },
            {
              title: '伊川法院',
              path: '',
              type: 4,
            },
            {
              title: '洛宁法院',
              path: '',
              type: 4,
            },
            {
              title: '西工法院',
              path: '',
              type: 4,
            }
          ]
        }
      ]
    }
  },
  {
    title: '山东省法院-网址导航',
    type: 1,
    detail: {
      title: '山东省高级法院',
      path: '',
      type: 2,
      list: [
        {
          title: '济南市中级法院',
          path: '',
          type: 3
        }
      ]
    }
  }
]
export {
  WebsiteList,
  cityList
}